module.exports = __webpack_public_path__ + "img/icon-coin.e936296a.png";